import NativeScrollbar from './native-scrollbar';

class BundleItem extends HTMLElement {
  constructor() {
    super();
    this.scrollbarHolder = this.querySelectorAll('[data-scrollbar]');
    this.formInput = this.querySelector('input[data-bundle-product-id]');
    this.links = this.querySelectorAll('a[href]');
    this.swatchLabel = this.querySelector('[data-swatch-label]');
    this.bundleWrapper = this.closest('[data-form-wrapper]')
    this.isEditBundle = this.bundleWrapper.hasAttribute('data-form-wrapper-bundle-edit');

    this.addEventListener('change', this.onVariantChange.bind(this));
    this.initNativeScrollbar();
    setTimeout(() => {this.updateButton()}, 0);
  }

  initNativeScrollbar() {
    if (this.scrollbarHolder.length) {
      this.scrollbarHolder.forEach((scrollbar) => {
        new NativeScrollbar(scrollbar);
      });
    }
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();

    if (this.currentVariant) {
      this.isAvailable();
      this.updateVariantInput();
      this.updateUrl();
      this.updateVariantImage();
      this.updateColorLabel();
      this.updateButton();
    }
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('.radio__buttons'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[data-product-variants]').textContent);

    return this.variantData;
  }

  updateVariantInput() {
    this.formInput.value = this.currentVariant.id;
  }

  updateUrl() {
    this.links.forEach((link) => {
      const productUrl = this.getAttribute('data-url');
      const newUrl = productUrl + '?variant=' + this.currentVariant.id
      link.setAttribute('href', newUrl);
    })
  }

  updateVariantImage() {
    const image = this.querySelector('.product-item__bg img');
    if (!this.currentVariant.featured_image || !image) return
    image.srcset = this.currentVariant.featured_image.src;
  }

  updateColorLabel() {
    if (!this.swatchLabel) return

    const checkedSwatch = this.querySelector('.swatch__button input:checked + label');
    if (checkedSwatch) {
      this.swatchLabel.textContent = checkedSwatch.getAttribute('data-swatch');
    }
  }

  isAvailable() {
    const isAvailable = this.currentVariant.available ? 'true' : 'false';
    this.setAttribute('data-available', isAvailable);
  }

  updateButton() {
    const bundleItems = this.bundleWrapper.querySelectorAll('bundle-item');
    const submitBtn = this.bundleWrapper.querySelector('[data-add-to-cart]')
    let bundleAvailable = true

    bundleItems.forEach(item => {
      if (item.getAttribute('data-available') === 'false') {
        bundleAvailable = false
      }
    })

    if (bundleAvailable) {
      submitBtn.removeAttribute('disabled');
      let btnText = this.isEditBundle ? theme.strings.updateBundle : theme.strings.addToCart
      submitBtn.querySelector('[data-add-to-cart-text]').textContent = btnText;
    } else {
      submitBtn.setAttribute('disabled', '');
      submitBtn.querySelector('[data-add-to-cart-text]').textContent = theme.strings.soldOut;
    }
  }

}

if (!customElements.get('bundle-item')) {
  customElements.define('bundle-item', BundleItem);
}
